/* ============================================================================
   Sonna — REVEALS  (premium GSAP motion: masked line reveals, image wipes,
   staggered words). Falls back to a simple IntersectionObserver if GSAP is
   unavailable, and no-ops under reduced motion.
   Shopify: init(scope) accepts an optional root so it can be re-run for a
   single section on `shopify:section:load`. Idempotent (won't re-split nodes).
   ============================================================================ */
window.SonnaReveals = (function () {
  function ioFallback(root) {
    const els = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    els.forEach((el) => { const d = parseFloat(el.getAttribute('data-reveal-delay')) || 0; if (d) el.style.transitionDelay = (d * 0.08) + 's'; });
    const io = new IntersectionObserver((ents) => ents.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  function init(scope) {
    const root = scope || document;
    const isDoc = root === document;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { root.querySelectorAll('[data-reveal]').forEach((e) => e.classList.add('is-in')); return; }
    const gsap = window.gsap;
    if (!gsap) { ioFallback(root); return; }

    const ST = window.ScrollTrigger; if (ST) gsap.registerPlugin(ST);
    const Split = window.SplitText; if (Split) { try { gsap.registerPlugin(Split); } catch (e) {} }
    document.body.classList.add('gsap-active');

    const vh = window.innerHeight;
    const inView = (el) => el.getBoundingClientRect().top < vh * 0.94;
    const st = (el, start) => (ST && !inView(el)) ? { trigger: el, start: start || 'top 84%' } : undefined;
    const soon = (el) => inView(el) ? 0.05 : 0;
    const done = (el) => el.dataset.revealed === '1';
    const mark = (el) => { el.dataset.revealed = '1'; };

    // ---- Headlines: split into lines, mask, rise with a soft 3D fold ----
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-text]')).forEach((el) => {
      if (done(el)) return; mark(el);
      let targets = [el];
      if (Split && !el.querySelector('.sl-mask')) {
        try {
          const sp = new Split(el, { type: 'lines', linesClass: 'sl-line' });
          sp.lines.forEach((ln) => { const m = document.createElement('span'); m.className = 'sl-mask'; ln.parentNode.insertBefore(m, ln); m.appendChild(ln); });
          targets = sp.lines;
        } catch (e) { targets = [el]; }
      }
      gsap.set(el, { opacity: 1 });
      gsap.fromTo(targets,
        { yPercent: 118, opacity: 0, rotateX: -55, transformOrigin: '50% 0%' },
        { yPercent: 0, opacity: 1, rotateX: 0, duration: 1.05, ease: 'power4.out', stagger: 0.085, delay: soon(el), scrollTrigger: st(el, 'top 86%') });
    });

    // ---- Lead / sub paragraphs: word-by-word soft rise ----
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-words]')).forEach((el) => {
      if (done(el)) return; mark(el);
      let targets = [el];
      if (Split) { try { targets = new Split(el, { type: 'words', wordsClass: 'sl-word' }).words; } catch (e) {} }
      gsap.fromTo(targets, { opacity: 0, y: 14, filter: 'blur(4px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, ease: 'power2.out', stagger: 0.018, delay: soon(el), scrollTrigger: st(el) });
    });

    // ---- Generic blocks: fade + rise ----
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach((el) => {
      if (done(el)) return; mark(el);
      const delay = (parseFloat(el.getAttribute('data-reveal-delay')) || 0) * 0.06 + soon(el);
      gsap.fromTo(el, { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.85, ease: 'power3.out', delay, scrollTrigger: st(el) });
    });

    // ---- Images: clip-path wipe-up + slow scale (premium reveal) ----
    gsap.utils.toArray(root.querySelectorAll('.split__media .ph, .annotated, .challenge .ph, .gallery__main .ph, .bundle__item .ph, .pageHero .ph')).forEach((el) => {
      if (done(el)) return; mark(el);
      gsap.fromTo(el, { clipPath: 'inset(0% 0% 100% 0%)', scale: 1.08 },
        { clipPath: 'inset(0% 0% 0% 0%)', scale: 1, duration: 1.2, ease: 'power3.out', delay: soon(el), scrollTrigger: st(el, 'top 88%') });
    });

    // ---- Hero: settle the bg image with a slow zoom-out (Ken Burns, subtle) ----
    const heroImg = root.querySelector('.es-hero__bg img, .es-hero__bg');
    if (heroImg && !done(heroImg)) { mark(heroImg); gsap.fromTo(heroImg, { scale: 1.12 }, { scale: 1, duration: 1.8, ease: 'power2.out' }); }

    if (ST) {
      ST.refresh();
      if (isDoc) {
        window.addEventListener('load', () => ST.refresh());
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ST.refresh());
      }
    }
  }
  return { init };
})();
